export const frTeams = {
    // TEAMS

    'teams.list.pageTitle': 'Équipes',
    'teams.list.sectionTitle': 'Équipes',
    'teams.list.emptyLabel': 'Aucune équipe pour le moment.',
    'teams.list.actions.addTeam': 'Ajouter une équipe',
    'teams.list.actions.importExcel': 'Import Excel',
    'teams.list.actions.exportExcel': 'Export Excel',
    'teams.list.item.floatingLabelTitle': 'Nom',

    // TEAMS >> CREATE

    'teams.create.pageTitle': 'Création équipe',
    'teams.create.input.name': "Saisissez ici le nom de l'Équipe *",
    'teams.create.input.code': "Saisissez ici le code de l'Équipe *",
    'teams.create.input.comment': 'Saisissez ici votre commentaire',
    'teams.create.input.floatingLabelName': 'Nom',
    'teams.create.input.floatingLabelCode': 'Code',
    'teams.create.input.floatingLabelComment': 'Commentaire',
    'teams.create.tabs.members': 'Membres',
    'teams.create.tabs.favorites': 'Centres Favoris',
    'teams.create.tabs.perms': 'Permissions',
    'teams.create.tabs.treeMenuTitle': 'Choix sectorisation',
    'teams.create.dialog.title': "Suppression de l'équipe",
    'teams.create.dialog.content':
        "Êtes-vous sûr de vouloir retirer l'utilisateur siège de cette équipe ?",
    'teams.create.dialog.validateLabel': 'Supprimer',
    'teams.create.dialog.cancelLabel': 'Annuler',
    'teams.create.selectUser.listTitle': "Choix de l'utilisateur siège",
    'teams.create.selectUser.inputLabel': 'Chercher un utilisateur siège',
    'teams.create.selectUser.closeLabel': 'Fermer',

    // TEAMS >> DETAILS

    'teams.details.pageTitle': 'Détails équipe',
    'teams.details.emptyLabel':
        "Appuyez sur le bouton « Ajouter un membre » afin d'ajouter un membre à l'équipe",
    'teams.details.sectionTitle': 'Utilisateurs siège',
    'teams.details.detailsInfo':
        "Pas d'utisateurs pour le moment. Pour en ajouter, appuyez sur l'icon « + ».",
    'teams.details.actions.save': 'Enregistrer',
    'teams.details.actions.removeTeam': "Supprimer l'équipe",
    'teams.details.actions.previous': 'Équipes',
    'teams.details.dialog.title': "Suppression de l'équipe",
    'teams.details.dialog.content': 'Êtes-vous sûr de vouloir supprimer cette équipe ?',
    'teams.details.dialog.validateLabel': 'Supprimer',
    'teams.details.dialog.cancelLabel': 'Annuler',
    'teams.details.selectUser.listTitle': "Choix de l'utilisateur siège",
    'teams.details.selectUser.inputLabel': 'Chercher un utilisateur siège',
    'teams.details.selectUser.closeLabel': 'Fermer',
    'teams.details.input.name': "Saisissez ici le nom de l'Équipe *",
    'teams.details.input.code': "Saisissez ici le code de l'Équipe *",
    'teams.details.input.comment': 'Saisissez ici votre commentaire',
    'teams.details.input.floatingLabelName': 'Nom',
    'teams.details.input.floatingLabelCode': 'Code',
    'teams.details.input.floatingLabelComment': 'Commentaire',
    'teams.details.tabs.userList.addUser': 'Ajouter un membre',
    'teams.details.tabs.userList.headers.info': 'Informations utilisateur',
    'teams.details.tabs.userList.headers.email': 'Email',
    'teams.details.tabs.userList.headers.comment': 'Commentaire',

    //TOAST
    'teams.import.success': 'Bravo! Équipes importés avec succès',
};
